var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.isLoading ? _c('div', {
    staticClass: "is-loading"
  }, [_c('b-spinner', {
    staticStyle: {
      "border-width": "2px"
    }
  })], 1) : _c('div', [_c('div', {
    staticClass: "dynamic-form-datetime-picker",
    class: {
      'd-flex': _vm.timeStyle === 'select_style'
    }
  }, [_c('DynamicFormDatePicker', {
    ref: "datePicker",
    attrs: {
      "hasError": _vm.hasError,
      "placeholder": _vm.placeholderForDate,
      "dateType": _vm.dateCondition,
      "dateOptions": _vm.dateTimeOptions,
      "disabled": _vm.disabled,
      "optionDisabler": function optionDisabler(dateOption) {
        return _vm.optionDisabler(dateOption, null);
      }
    },
    on: {
      "input": _vm.handleInput
    },
    model: {
      value: _vm.date,
      callback: function callback($$v) {
        _vm.date = $$v;
      },
      expression: "date"
    }
  }), _c('DynamicFormTimePicker', {
    attrs: {
      "hasError": _vm.hasError,
      "placeholder": _vm.placeholderForTime,
      "start-time": _vm.startTime,
      "end-time": _vm.endTime,
      "style-type": _vm.timeCondition,
      "slot-minutes": _vm.slotMinutes,
      "time-style": _vm.timeStyle,
      "custom-time-options": _vm.resolvedCustomTimeOptions,
      "disabled": _vm.disabled,
      "optionDisabler": function optionDisabler(timeOption) {
        return _vm.optionDisabler(_vm.date, timeOption);
      }
    },
    on: {
      "input": _vm.handleInput
    },
    model: {
      value: _vm.time,
      callback: function callback($$v) {
        _vm.time = $$v;
      },
      expression: "time"
    }
  })], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }